export const createPerformanceRoutes = (basePath: string) =>
  ({
    index: basePath,
    reports: {
      index: `${basePath}/reports`,
      time: `${basePath}/reports/time`,
      team: `${basePath}/reports/team`,
      jobs: `${basePath}/reports/jobs`,
      jobDetail: (jobId: string) => `${basePath}/reports/jobs/${jobId}`,
    },
  }) as const;
